import { startCase } from 'es-toolkit';

import { MagnitudeUnit, ModelCategory, MovingLoadSettings } from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { ModelSchema } from '../ModelSchema';

export const createMagnitudeFormatter = (magnitudeUnit: MagnitudeUnit) => (magnitude: number) => {
  switch (magnitudeUnit) {
    case 'Pounds':
      const plural = magnitude !== 1;
      return `${magnitude} lb${plural ? 's' : ''}`;
    case 'PoundsPerLinearFoot':
      return `${magnitude} plf`;
    case 'PoundsPerSquareFoot':
      return `${magnitude} psf`;
    default:
      assertExhaustiveSwitch(magnitudeUnit);
  }
};

export const MovingLoadSchema = new ModelSchema<MovingLoadSettings>('movingLoad', {
  category: ModelCategory.ComponentDesignData,
  displayName: (movingLoad) => {
    if (movingLoad.name) {
      return movingLoad.name;
    }
    const formatMagnitude = createMagnitudeFormatter(movingLoad.magnitudeUnit);
    const magnitude = formatMagnitude(movingLoad.loadMagnitude);

    return `${startCase(movingLoad.loadType)} ${startCase(movingLoad.alongMemberType)} ${magnitude}`;
  },

  properties: {},
});
